import React, { useState } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { ResponsiveShell } from '../../components/ResponsiveShell';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { height: 100%; overflow: hidden; }
  body {
    font-family: 'Noto Sans KR', sans-serif;
    background: #E8E0C8;
    color: #5C5040;
    -webkit-font-smoothing: antialiased;
    height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #root {
    width: 100%;
    height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
`;



/* ─── Stagger List Animation ────────────────────────────────────────────── */
const listContainer = {
  animate: { transition: { staggerChildren: 0.07, delayChildren: 0.05 } },
};
const listItem = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0, transition: { type: 'spring' as const, stiffness: 320, damping: 26 } },
};

const PhoneNavBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 12px;
  flex-shrink: 0;
  background: rgba(249, 246, 232, 0.95);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1.5px solid #EDE9D5;
`;

const BackBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #EDE9D5;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s, transform 0.15s;
  color: #5C5040;
  &:hover { background: #E0D8C0; transform: scale(1.05); }
  &:active { transform: scale(0.95); }
`;

const NavTitle = styled.h2`
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #3D3020;
  flex: 1;
`;

const PhoneBody = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-top: 16px;
`;

const PostCard = styled(motion.div)`
  margin: 0 16px 10px;
  padding: 16px;
  background: #fff;
  border-radius: 18px;
  border: 1.5px solid #EDE9D5;
  box-shadow: 0 3px 12px rgba(90,60,30,0.07);
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(90,60,30,0.1);
  }
`;

const PostTitle = styled.h3`
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: #3D3020;
  margin-bottom: 6px;
`;

const PostDate = styled.p`
  font-size: 12px;
  color: #B0A090;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const ModalOverlay = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(40, 30, 20, 0.6);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.3s ease-out;
  backdrop-filter: blur(4px);
`;

const ModalPaper = styled.div`
  background: #FDFBF4;
  width: 85%;
  max-height: 85%;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0,0,0,0.25);
  padding: 30px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  background-image: repeating-linear-gradient(transparent, transparent 27px, #EDE9D5 28px);
  background-attachment: local;
  background-position: 0 8px;
  animation: ${slideUp} 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
`;

const ModalHeader = styled.div`
  font-family: 'Jua', sans-serif;
  color: #8A3324;
  font-size: 16px;
  margin-bottom: 24px;
  border-bottom: 2px dashed #E8E0C8;
  padding-bottom: 12px;
`;

const ModalTitleContent = styled.div`
  font-size: 20px;
  color: #5C5040;
  margin-top: 8px;
`;

const ModalContent = styled.div`
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  line-height: 28px;
  color: #332B20;
  overflow-y: auto;
  flex: 1;
  white-space: pre-wrap;
  &::-webkit-scrollbar { display: none; }
`;

const ModalCloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: #F9F6E8;
  border: none;
  border-radius: 50%;
  width: 32px; height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8A3324;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(138, 51, 36, 0.2);
  transition: transform 0.2s;
  &:active { transform: scale(0.9); }
`;

export default function BetaLetter() {
  const [selectedPost, setSelectedPost] = useState<any>(null);

  const posts = [
    {
      id: 3,
      title: 'V 1.0.3 업데이트 내역',
      date: '2026.06.12',
      content: '• 이모티콘 기능을 테스트 중에 있습니다\n\n• 알람 기능은 잠시 비활성화 처리 되었습니다'
    },
    {
      id: 2,
      title: 'V 1.0.2 업데이트 내역',
      date: '2026.06.11',
      content: '• 바탕 화면 빠른메뉴가 저장되어 다른 기기나 탭에서 내가 정한 위치 그대로 사용할 수 있습니다\n\n• 알람기능을 테스트하고 있습니다'
    },
    {
      id: 1,
      title: 'v1.0.1 이름 검색 추가',
      date: '2026.06.10',
      content: '이름을 검색하면 비슷한 유저가 먼저 표시되게 업데이트 되었습니다'
    }
  ];

  return (
    <>
      <GlobalStyle />
      <ResponsiveShell>
        <PhoneNavBar>
          <BackBtn onClick={() => { window.location.href = '/'; }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </BackBtn>
          <NavTitle>베타 내역</NavTitle>
        </PhoneNavBar>

        <PhoneBody>
          <motion.div variants={listContainer} initial="initial" animate="animate">
            {posts.map(post => (
              <PostCard key={post.id} variants={listItem} onClick={() => setSelectedPost(post)}>
                <PostTitle>{post.title}</PostTitle>
                <PostDate>{post.date}</PostDate>
              </PostCard>
            ))}
          </motion.div>
        </PhoneBody>

        {selectedPost && (
          <ModalOverlay onClick={() => setSelectedPost(null)}>
            <ModalPaper onClick={e => e.stopPropagation()}>
              <ModalCloseBtn onClick={() => setSelectedPost(null)}>✕</ModalCloseBtn>
              <ModalHeader>
                <div>업데이트 내역</div>
                <ModalTitleContent>{selectedPost.title}</ModalTitleContent>
              </ModalHeader>
              <ModalContent>
                {selectedPost.content}
              </ModalContent>
            </ModalPaper>
          </ModalOverlay>
        )}
      </ResponsiveShell>
    </>
  );
}
